export default [
    {
        "value": "ConceitoOuMetodologia",
        "text": "Conceito ou Metodologia"
    },
    {
        "value": "Software",
        "text": "Software"
    },
    {
        "value": "Sistema",
        "text": "Sistema"
    },
    {
        "value": "MaterialOuSubstancia",
        "text": "Material ou Substância"
    },
    {
        "value": "ComponenteOuDispositivo",
        "text": "Componente ou Dispositivo"
    },
    {
        "value": "MaquinaOuEquipamento",
        "text": "Máquina ou Equipamento"
    }
]